import { Popover, Stack } from '@mui/material';
import { PromptGroup } from '@server/prompts';
import { colors, IconButton, Typography } from '@sweep-io/sweep-design';
import AgentPrompts from '../AgentPrompts';
import { Close } from '@sweep-io/sweep-design/dist/icons';
import { useState } from 'react';
import { PromptLibraryIcon } from './PromptLibraryIcon';

interface PromptGroupMinimizedPopoverProps {
  prompt: PromptGroup;
  onClose: () => void;
  onPromptClick: (promptText: string) => Promise<void>;
  anchorEl: HTMLDivElement | null;
}
export const PromptGroupMinimizedPopover = ({
  prompt,
  onClose,
  anchorEl,
  onPromptClick,
}: PromptGroupMinimizedPopoverProps) => {
  const { prompts, name, iconName: icon } = prompt;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const promptClickHandler = async (prompt: string) => {
    setIsSubmitting(true);
    await onPromptClick(prompt);
    setIsSubmitting(false);
  };
  return (
    <Popover
      open={true}
      onClose={onClose}
      anchorEl={anchorEl}
      disablePortal
      anchorPosition={{ top: 100, left: 100 }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 10,
        horizontal: 'center',
      }}
      slotProps={{
        paper: {
          style: {
            boxShadow: 'none',
            border: `1px solid ${colors.grey[300]}`,
            borderRadius: '12px',
          },
        },
      }}
    >
      <Stack gap={0.5} p={2} width="656px" height="100%">
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" gap={2} pl={1.5}>
            <PromptLibraryIcon icon={icon} />
            <Typography variant="h5">{name}</Typography>
          </Stack>
          <IconButton onClick={onClose} variant="flat" size="small">
            <Close />
          </IconButton>
        </Stack>
        <AgentPrompts
          prompts={prompts}
          onClickPrompt={promptClickHandler}
          isDisabled={isSubmitting}
        />
      </Stack>
    </Popover>
  );
};
